import { Grid, List } from "lucide-react";

export const LayoutToggle = ({ current, onChange }) => {
  return (
    <div className="flex gap-2 bg-white/10 p-1 rounded-md">
      <button
        onClick={() => onChange('list')}
        className={`px-3 py-1 text-sm rounded-md ${
          current === 'list' ? 'bg-white/20 text-white' : 'text-white/50'
        }`}
      >
        <List />
      </button>
      <button
        onClick={() => onChange('grid')}
        className={`px-3 py-1 text-sm rounded-md ${
          current === 'grid' ? 'bg-white/20 text-white' : 'text-white/50'
        }`}
      >
        <Grid />
      </button>
    </div>
  );
};
